import { useState } from 'react';
import PropTypes from 'prop-types';
import hexRgba from 'hex-rgba';
import { color } from '../../../app/theme';

function IconX16({ className }) {
  const [isHover, setIsHover] = useState(false);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <circle
        cx="8"
        cy="8"
        r="8"
        fill={isHover ? hexRgba(color.$10, 40) : color.$10}
      />
      <mask
        id="iconX16"
        maskUnits="userSpaceOnUse"
        x="4"
        y="4"
        width="8"
        height="8"
      >
        <path
          d="M11.19 10.523a.46.46 0 0 1 0 .667.432.432 0 0 1-.332.143.432.432 0 0 1-.334-.143L8 8.666 5.477 11.19a.432.432 0 0 1-.334.143.432.432 0 0 1-.333-.143.46.46 0 0 1 0-.667L7.334 8 4.81 5.476a.46.46 0 0 1 0-.667.46.46 0 0 1 .667 0L8 7.333l2.524-2.524a.46.46 0 0 1 .667 0 .46.46 0 0 1 0 .667L8.667 7.999l2.524 2.524z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#iconX16)">
        <path fill="#fff" d="M1.333 1.333h13.333v13.333H1.333z" />
      </g>
    </svg>
  );
}

IconX16.defaultProps = {
  className: undefined,
};

IconX16.propTypes = {
  className: PropTypes.string,
};

export default IconX16;
